import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AdminUser = {
  firstname: Scalars['String'];
  id: Scalars['ID'];
  lastname: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export type Category = {
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<Category>;
  posts?: Maybe<Array<Maybe<Post>>>;
  scope?: Maybe<Enum_Category_Scope>;
  slug: Scalars['String'];
};


export type CategoryPostsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type CategoryAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CategoryConnection = {
  aggregate?: Maybe<CategoryAggregator>;
  groupBy?: Maybe<CategoryGroupBy>;
  values?: Maybe<Array<Maybe<Category>>>;
};

export type CategoryConnectionId = {
  connection?: Maybe<CategoryConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type CategoryConnectionName = {
  connection?: Maybe<CategoryConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CategoryConnectionParent = {
  connection?: Maybe<CategoryConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type CategoryConnectionScope = {
  connection?: Maybe<CategoryConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CategoryConnectionSlug = {
  connection?: Maybe<CategoryConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CategoryGroupBy = {
  id?: Maybe<Array<Maybe<CategoryConnectionId>>>;
  name?: Maybe<Array<Maybe<CategoryConnectionName>>>;
  parent?: Maybe<Array<Maybe<CategoryConnectionParent>>>;
  scope?: Maybe<Array<Maybe<CategoryConnectionScope>>>;
  slug?: Maybe<Array<Maybe<CategoryConnectionSlug>>>;
};

export type CategoryInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  parent?: InputMaybe<Scalars['ID']>;
  posts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  scope?: InputMaybe<Enum_Category_Scope>;
  slug: Scalars['String'];
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type ComponentAtomsButton = {
  id: Scalars['ID'];
  link?: Maybe<ComponentAtomsLink>;
  simpleIcon?: Maybe<Scalars['String']>;
};

export type ComponentAtomsButtonInput = {
  link: ComponentAtomsLinkInput;
  simpleIcon?: InputMaybe<Scalars['String']>;
};

/** Key-Value entry */
export type ComponentAtomsEntry = {
  id: Scalars['ID'];
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type ComponentAtomsEntryInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type ComponentAtomsLink = {
  id: Scalars['ID'];
  text: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ComponentAtomsLinkInput = {
  text: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ComponentAtomsNumeric = {
  id: Scalars['ID'];
  unit?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type ComponentAtomsNumericInput = {
  unit?: InputMaybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type ComponentAtomsParagraph = {
  id: Scalars['ID'];
  lines?: Maybe<Array<Maybe<ComponentAtomsText>>>;
};

export type ComponentAtomsParagraphInput = {
  lines?: InputMaybe<Array<InputMaybe<ComponentAtomsTextInput>>>;
};

/** Text node */
export type ComponentAtomsText = {
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type ComponentAtomsTextInput = {
  value: Scalars['String'];
};

export type ComponentMoleculesDescription = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type ComponentMoleculesDescriptionInput = {
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ComponentMoleculesEmailInput = {
  email?: InputMaybe<Scalars['String']>;
};

export type ComponentMoleculesEmails = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ComponentMoleculesFeedbackText = {
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ComponentMoleculesFeedbackTextInput = {
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ComponentMoleculesItem = {
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type ComponentMoleculesItemInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type ComponentMoleculesList = {
  feature01?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ComponentMoleculesListInput = {
  feature01?: InputMaybe<Scalars['String']>;
};

/** Collection<Entry> */
export type ComponentMoleculesMap = {
  entries?: Maybe<Array<Maybe<ComponentAtomsEntry>>>;
  id: Scalars['ID'];
  slug: Scalars['String'];
};

export type ComponentMoleculesMapInput = {
  entries?: InputMaybe<Array<ComponentAtomsEntryInput>>;
  slug: Scalars['String'];
};

export type ComponentMoleculesMenu = {
  id: Scalars['ID'];
  links?: Maybe<Array<Maybe<ComponentAtomsLink>>>;
  slug: Scalars['String'];
};

export type ComponentMoleculesMenuInput = {
  links?: InputMaybe<Array<InputMaybe<ComponentAtomsLinkInput>>>;
  slug?: InputMaybe<Scalars['String']>;
};

export type ComponentMoleculesPrivacy = {
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ComponentMoleculesPrivacyInput = {
  link?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ComponentMoleculesSocialInput = {
  icon?: InputMaybe<Scalars['ID']>;
  link?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ComponentMoleculesSocials = {
  icon?: Maybe<UploadFile>;
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Content building block - defines section, slides, rows and columns and link or button */
export type ComponentOrganismsArticle = {
  cards?: Maybe<Array<Maybe<ComponentOrganismsSection>>>;
  entries?: Maybe<Array<Maybe<ComponentAtomsEntry>>>;
  id: Scalars['ID'];
  link?: Maybe<ComponentAtomsLink>;
  section?: Maybe<ComponentOrganismsSection>;
  slug: Scalars['String'];
};

export type ComponentOrganismsArticleInput = {
  cards?: InputMaybe<Array<ComponentOrganismsSectionInput>>;
  entries?: InputMaybe<Array<InputMaybe<ComponentAtomsEntryInput>>>;
  link?: InputMaybe<ComponentAtomsLinkInput>;
  section: ComponentOrganismsSectionInput;
  slug: Scalars['String'];
};

export type ComponentOrganismsDescriptionCard = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type ComponentOrganismsDescriptionCardInput = {
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ComponentOrganismsPage = {
  id: Scalars['ID'];
  meta?: Maybe<Array<Maybe<ComponentAtomsEntry>>>;
  uri: Scalars['String'];
};

export type ComponentOrganismsPageInput = {
  meta?: InputMaybe<Array<InputMaybe<ComponentAtomsEntryInput>>>;
  uri: Scalars['String'];
};

export type ComponentOrganismsSection = {
  Features?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  activeFirstButton?: Maybe<Scalars['Boolean']>;
  backgroundColor?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  formIdModal?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  media?: Maybe<UploadFile>;
  media_slides?: Maybe<Array<Maybe<UploadFile>>>;
  slug?: Maybe<Scalars['String']>;
  subDescription?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  urlButton?: Maybe<Scalars['String']>;
  videoDesktop?: Maybe<UploadFile>;
  videoMobile?: Maybe<UploadFile>;
};


export type ComponentOrganismsSectionMedia_SlidesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type ComponentOrganismsSectionInput = {
  Features?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  activeFirstButton?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  formIdModal?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Scalars['ID']>;
  media_slides?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  slug?: InputMaybe<Scalars['String']>;
  subDescription?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  urlButton?: InputMaybe<Scalars['String']>;
  videoDesktop?: InputMaybe<Scalars['ID']>;
  videoMobile?: InputMaybe<Scalars['ID']>;
};

export type ComponentSeoMeta = {
  content: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Enum_Componentseometa_Name>;
};

export type ComponentSeoMetaInput = {
  content: Scalars['String'];
  name?: InputMaybe<Enum_Componentseometa_Name>;
};

export type ComponentSeoMetaName = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type ComponentSeoMetaNameInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type ContactFormRequest = {
  clubName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type ContactFormRequestAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ContactFormRequestConnection = {
  aggregate?: Maybe<ContactFormRequestAggregator>;
  groupBy?: Maybe<ContactFormRequestGroupBy>;
  values?: Maybe<Array<Maybe<ContactFormRequest>>>;
};

export type ContactFormRequestConnectionClubName = {
  connection?: Maybe<ContactFormRequestConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ContactFormRequestConnectionEmail = {
  connection?: Maybe<ContactFormRequestConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ContactFormRequestConnectionFirstName = {
  connection?: Maybe<ContactFormRequestConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ContactFormRequestConnectionId = {
  connection?: Maybe<ContactFormRequestConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ContactFormRequestConnectionLastName = {
  connection?: Maybe<ContactFormRequestConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ContactFormRequestConnectionPhone = {
  connection?: Maybe<ContactFormRequestConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ContactFormRequestConnectionWebsite = {
  connection?: Maybe<ContactFormRequestConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ContactFormRequestGroupBy = {
  clubName?: Maybe<Array<Maybe<ContactFormRequestConnectionClubName>>>;
  email?: Maybe<Array<Maybe<ContactFormRequestConnectionEmail>>>;
  firstName?: Maybe<Array<Maybe<ContactFormRequestConnectionFirstName>>>;
  id?: Maybe<Array<Maybe<ContactFormRequestConnectionId>>>;
  lastName?: Maybe<Array<Maybe<ContactFormRequestConnectionLastName>>>;
  phone?: Maybe<Array<Maybe<ContactFormRequestConnectionPhone>>>;
  website?: Maybe<Array<Maybe<ContactFormRequestConnectionWebsite>>>;
};

export type ContactFormRequestInput = {
  clubName: Scalars['String'];
  created_by?: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  website?: InputMaybe<Scalars['String']>;
};

export type ContentBlock = {
  button?: Maybe<ComponentAtomsButton>;
  cards?: Maybe<Array<Maybe<ComponentOrganismsSection>>>;
  description?: Maybe<Scalars['String']>;
  entries?: Maybe<Array<Maybe<ComponentMoleculesMap>>>;
  id: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<ContentBlock>>>;
  section?: Maybe<ComponentOrganismsSection>;
  slug: Scalars['String'];
  title: Scalars['String'];
};


export type ContentBlockLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type ContentBlockAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ContentBlockConnection = {
  aggregate?: Maybe<ContentBlockAggregator>;
  groupBy?: Maybe<ContentBlockGroupBy>;
  values?: Maybe<Array<Maybe<ContentBlock>>>;
};

export type ContentBlockConnectionButton = {
  connection?: Maybe<ContentBlockConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ContentBlockConnectionDescription = {
  connection?: Maybe<ContentBlockConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ContentBlockConnectionId = {
  connection?: Maybe<ContentBlockConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ContentBlockConnectionLocale = {
  connection?: Maybe<ContentBlockConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ContentBlockConnectionSection = {
  connection?: Maybe<ContentBlockConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ContentBlockConnectionSlug = {
  connection?: Maybe<ContentBlockConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ContentBlockConnectionTitle = {
  connection?: Maybe<ContentBlockConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ContentBlockGroupBy = {
  button?: Maybe<Array<Maybe<ContentBlockConnectionButton>>>;
  description?: Maybe<Array<Maybe<ContentBlockConnectionDescription>>>;
  id?: Maybe<Array<Maybe<ContentBlockConnectionId>>>;
  locale?: Maybe<Array<Maybe<ContentBlockConnectionLocale>>>;
  section?: Maybe<Array<Maybe<ContentBlockConnectionSection>>>;
  slug?: Maybe<Array<Maybe<ContentBlockConnectionSlug>>>;
  title?: Maybe<Array<Maybe<ContentBlockConnectionTitle>>>;
};

export type ContentBlockInput = {
  button?: InputMaybe<ComponentAtomsButtonInput>;
  cards?: InputMaybe<Array<InputMaybe<ComponentOrganismsSectionInput>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  entries?: InputMaybe<Array<InputMaybe<ComponentMoleculesMapInput>>>;
  locale?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  section?: InputMaybe<ComponentOrganismsSectionInput>;
  slug: Scalars['String'];
  title: Scalars['String'];
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type Enum_Category_Scope =
  | 'storybook'
  | 'website';

export type Enum_Componentseometa_Name =
  | 'apple_touch_icon'
  | 'author'
  | 'description'
  | 'keywords'
  | 'msapplication_TileColor'
  | 'og__image__heigth'
  | 'og__image__width'
  | 'twitter__card'
  | 'twitter__description'
  | 'twitter__image'
  | 'twitter__title';

export type EmailDesignerEmailTemplate = {
  bodyHtml?: Maybe<Scalars['String']>;
  bodyText?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  design?: Maybe<Scalars['JSON']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  sourceCodeToTemplateId?: Maybe<Scalars['Int']>;
  subject?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['JSON']>;
  updated_at: Scalars['DateTime'];
};

export type EmailTemplateInput = {
  bodyHtml?: InputMaybe<Scalars['String']>;
  bodyText?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  design?: InputMaybe<Scalars['JSON']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  sourceCodeToTemplateId?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['JSON']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type Feedback = {
  client?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  decktop_slide?: Maybe<UploadFile>;
  feedbackText?: Maybe<Array<Maybe<ComponentMoleculesFeedbackText>>>;
  id: Scalars['ID'];
  isInvert?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<UploadFile>;
  mobile_slide?: Maybe<UploadFile>;
  person?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type FeedbackAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type FeedbackConnection = {
  aggregate?: Maybe<FeedbackAggregator>;
  groupBy?: Maybe<FeedbackGroupBy>;
  values?: Maybe<Array<Maybe<Feedback>>>;
};

export type FeedbackConnectionClient = {
  connection?: Maybe<FeedbackConnection>;
  key?: Maybe<Scalars['String']>;
};

export type FeedbackConnectionCreated_At = {
  connection?: Maybe<FeedbackConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type FeedbackConnectionDecktop_Slide = {
  connection?: Maybe<FeedbackConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type FeedbackConnectionId = {
  connection?: Maybe<FeedbackConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type FeedbackConnectionIsInvert = {
  connection?: Maybe<FeedbackConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type FeedbackConnectionLogo = {
  connection?: Maybe<FeedbackConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type FeedbackConnectionMobile_Slide = {
  connection?: Maybe<FeedbackConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type FeedbackConnectionPerson = {
  connection?: Maybe<FeedbackConnection>;
  key?: Maybe<Scalars['String']>;
};

export type FeedbackConnectionUpdated_At = {
  connection?: Maybe<FeedbackConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type FeedbackGroupBy = {
  client?: Maybe<Array<Maybe<FeedbackConnectionClient>>>;
  created_at?: Maybe<Array<Maybe<FeedbackConnectionCreated_At>>>;
  decktop_slide?: Maybe<Array<Maybe<FeedbackConnectionDecktop_Slide>>>;
  id?: Maybe<Array<Maybe<FeedbackConnectionId>>>;
  isInvert?: Maybe<Array<Maybe<FeedbackConnectionIsInvert>>>;
  logo?: Maybe<Array<Maybe<FeedbackConnectionLogo>>>;
  mobile_slide?: Maybe<Array<Maybe<FeedbackConnectionMobile_Slide>>>;
  person?: Maybe<Array<Maybe<FeedbackConnectionPerson>>>;
  updated_at?: Maybe<Array<Maybe<FeedbackConnectionUpdated_At>>>;
};

export type FeedbackInput = {
  client?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  decktop_slide?: InputMaybe<Scalars['ID']>;
  feedbackText?: InputMaybe<Array<InputMaybe<ComponentMoleculesFeedbackTextInput>>>;
  isInvert?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['ID']>;
  mobile_slide?: InputMaybe<Scalars['ID']>;
  person?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FileInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  ext?: InputMaybe<Scalars['String']>;
  formats?: InputMaybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height?: InputMaybe<Scalars['Int']>;
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl?: InputMaybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: InputMaybe<Scalars['JSON']>;
  related?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  size: Scalars['Float'];
  updated_by?: InputMaybe<Scalars['ID']>;
  url: Scalars['String'];
  width?: InputMaybe<Scalars['Int']>;
};

export type Footer = {
  address?: Maybe<Scalars['String']>;
  addressMapUrl?: Maybe<Scalars['String']>;
  contactsTitle?: Maybe<Scalars['String']>;
  copyrights?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  emails?: Maybe<Array<Maybe<ComponentMoleculesEmails>>>;
  id: Scalars['ID'];
  phone?: Maybe<Scalars['String']>;
  privacy?: Maybe<ComponentMoleculesPrivacy>;
  socials?: Maybe<Array<Maybe<ComponentMoleculesSocials>>>;
  starText?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type FooterAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type FooterConnection = {
  aggregate?: Maybe<FooterAggregator>;
  groupBy?: Maybe<FooterGroupBy>;
  values?: Maybe<Array<Maybe<Footer>>>;
};

export type FooterConnectionAddress = {
  connection?: Maybe<FooterConnection>;
  key?: Maybe<Scalars['String']>;
};

export type FooterConnectionAddressMapUrl = {
  connection?: Maybe<FooterConnection>;
  key?: Maybe<Scalars['String']>;
};

export type FooterConnectionContactsTitle = {
  connection?: Maybe<FooterConnection>;
  key?: Maybe<Scalars['String']>;
};

export type FooterConnectionCopyrights = {
  connection?: Maybe<FooterConnection>;
  key?: Maybe<Scalars['String']>;
};

export type FooterConnectionCreated_At = {
  connection?: Maybe<FooterConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type FooterConnectionId = {
  connection?: Maybe<FooterConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type FooterConnectionPhone = {
  connection?: Maybe<FooterConnection>;
  key?: Maybe<Scalars['String']>;
};

export type FooterConnectionPrivacy = {
  connection?: Maybe<FooterConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type FooterConnectionStarText = {
  connection?: Maybe<FooterConnection>;
  key?: Maybe<Scalars['String']>;
};

export type FooterConnectionUpdated_At = {
  connection?: Maybe<FooterConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type FooterGroupBy = {
  address?: Maybe<Array<Maybe<FooterConnectionAddress>>>;
  addressMapUrl?: Maybe<Array<Maybe<FooterConnectionAddressMapUrl>>>;
  contactsTitle?: Maybe<Array<Maybe<FooterConnectionContactsTitle>>>;
  copyrights?: Maybe<Array<Maybe<FooterConnectionCopyrights>>>;
  created_at?: Maybe<Array<Maybe<FooterConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<FooterConnectionId>>>;
  phone?: Maybe<Array<Maybe<FooterConnectionPhone>>>;
  privacy?: Maybe<Array<Maybe<FooterConnectionPrivacy>>>;
  starText?: Maybe<Array<Maybe<FooterConnectionStarText>>>;
  updated_at?: Maybe<Array<Maybe<FooterConnectionUpdated_At>>>;
};

export type FooterInput = {
  address?: InputMaybe<Scalars['String']>;
  addressMapUrl?: InputMaybe<Scalars['String']>;
  contactsTitle?: InputMaybe<Scalars['String']>;
  copyrights?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  emails?: InputMaybe<Array<InputMaybe<ComponentMoleculesEmailInput>>>;
  phone?: InputMaybe<Scalars['String']>;
  privacy?: InputMaybe<ComponentMoleculesPrivacyInput>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  socials?: InputMaybe<Array<InputMaybe<ComponentMoleculesSocialInput>>>;
  starText?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type I18NLocale = {
  code?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type InputId = {
  id: Scalars['ID'];
};

export type LocaleInput = {
  code?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type Meta = {
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  meta?: Maybe<Array<Maybe<ComponentSeoMeta>>>;
  pathname: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type MetaAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaConnection = {
  aggregate?: Maybe<MetaAggregator>;
  groupBy?: Maybe<MetaGroupBy>;
  values?: Maybe<Array<Maybe<Meta>>>;
};

export type MetaConnectionCreated_At = {
  connection?: Maybe<MetaConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type MetaConnectionId = {
  connection?: Maybe<MetaConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type MetaConnectionPathname = {
  connection?: Maybe<MetaConnection>;
  key?: Maybe<Scalars['String']>;
};

export type MetaConnectionTitle = {
  connection?: Maybe<MetaConnection>;
  key?: Maybe<Scalars['String']>;
};

export type MetaConnectionUpdated_At = {
  connection?: Maybe<MetaConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type MetaGroupBy = {
  created_at?: Maybe<Array<Maybe<MetaConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<MetaConnectionId>>>;
  pathname?: Maybe<Array<Maybe<MetaConnectionPathname>>>;
  title?: Maybe<Array<Maybe<MetaConnectionTitle>>>;
  updated_at?: Maybe<Array<Maybe<MetaConnectionUpdated_At>>>;
};

export type MetaInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  meta?: InputMaybe<Array<InputMaybe<ComponentSeoMetaInput>>>;
  pathname?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type Morph = Category | CategoryAggregator | CategoryConnection | CategoryConnectionId | CategoryConnectionName | CategoryConnectionParent | CategoryConnectionScope | CategoryConnectionSlug | CategoryGroupBy | ComponentAtomsButton | ComponentAtomsEntry | ComponentAtomsLink | ComponentAtomsNumeric | ComponentAtomsParagraph | ComponentAtomsText | ComponentMoleculesDescription | ComponentMoleculesEmails | ComponentMoleculesFeedbackText | ComponentMoleculesItem | ComponentMoleculesList | ComponentMoleculesMap | ComponentMoleculesMenu | ComponentMoleculesPrivacy | ComponentMoleculesSocials | ComponentOrganismsArticle | ComponentOrganismsDescriptionCard | ComponentOrganismsPage | ComponentOrganismsSection | ComponentSeoMeta | ComponentSeoMetaName | ContactFormRequest | ContactFormRequestAggregator | ContactFormRequestConnection | ContactFormRequestConnectionClubName | ContactFormRequestConnectionEmail | ContactFormRequestConnectionFirstName | ContactFormRequestConnectionId | ContactFormRequestConnectionLastName | ContactFormRequestConnectionPhone | ContactFormRequestConnectionWebsite | ContactFormRequestGroupBy | ContentBlock | ContentBlockAggregator | ContentBlockConnection | ContentBlockConnectionButton | ContentBlockConnectionDescription | ContentBlockConnectionId | ContentBlockConnectionLocale | ContentBlockConnectionSection | ContentBlockConnectionSlug | ContentBlockConnectionTitle | ContentBlockGroupBy | EmailDesignerEmailTemplate | Feedback | FeedbackAggregator | FeedbackConnection | FeedbackConnectionClient | FeedbackConnectionCreated_At | FeedbackConnectionDecktop_Slide | FeedbackConnectionId | FeedbackConnectionIsInvert | FeedbackConnectionLogo | FeedbackConnectionMobile_Slide | FeedbackConnectionPerson | FeedbackConnectionUpdated_At | FeedbackGroupBy | Footer | FooterAggregator | FooterConnection | FooterConnectionAddress | FooterConnectionAddressMapUrl | FooterConnectionContactsTitle | FooterConnectionCopyrights | FooterConnectionCreated_At | FooterConnectionId | FooterConnectionPhone | FooterConnectionPrivacy | FooterConnectionStarText | FooterConnectionUpdated_At | FooterGroupBy | I18NLocale | Meta | MetaAggregator | MetaConnection | MetaConnectionCreated_At | MetaConnectionId | MetaConnectionPathname | MetaConnectionTitle | MetaConnectionUpdated_At | MetaGroupBy | Occupation | OccupationAggregator | OccupationConnection | OccupationConnectionId | OccupationConnectionName | OccupationGroupBy | Platforms | PlatformsAggregator | PlatformsConnection | PlatformsConnectionCreated_At | PlatformsConnectionFeatures_Title | PlatformsConnectionId | PlatformsConnectionLogo | PlatformsConnectionPreview | PlatformsConnectionSubTitle | PlatformsConnectionTitle | PlatformsConnectionUpdated_At | PlatformsGroupBy | Post | PostAggregator | PostConnection | PostConnectionCategory | PostConnectionId | PostConnectionLocale | PostConnectionName | PostConnectionPreviews | PostConnectionSlug | PostConnectionSource | PostConnectionText | PostGroupBy | Redirect | RedirectAggregator | RedirectConnection | RedirectConnectionFrom | RedirectConnectionId | RedirectConnectionTo | RedirectGroupBy | TestCollection | TestCollectionAggregator | TestCollectionConnection | TestCollectionConnectionCreated_At | TestCollectionConnectionId | TestCollectionConnectionTestTitle | TestCollectionConnectionUpdated_At | TestCollectionGroupBy | UploadFile | UploadFileAggregator | UploadFileAggregatorAvg | UploadFileAggregatorMax | UploadFileAggregatorMin | UploadFileAggregatorSum | UploadFileConnection | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionCreated_At | UploadFileConnectionExt | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionHeight | UploadFileConnectionId | UploadFileConnectionMime | UploadFileConnectionName | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | UploadFileConnectionSize | UploadFileConnectionUpdated_At | UploadFileConnectionUrl | UploadFileConnectionWidth | UploadFileGroupBy | UserPermissionsPasswordPayload | UsersPermissionsLoginPayload | UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleAggregator | UsersPermissionsRoleConnection | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionType | UsersPermissionsRoleGroupBy | UsersPermissionsUser | UsersPermissionsUserAggregator | UsersPermissionsUserConnection | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionFirstName | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionLastName | UsersPermissionsUserConnectionOccupation | UsersPermissionsUserConnectionPhoto | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionUsername | UsersPermissionsUserGroupBy | Website | WebsiteAggregator | WebsiteConnection | WebsiteConnectionDomain | WebsiteConnectionId | WebsiteGroupBy | CreateCategoryPayload | CreateContactFormRequestPayload | CreateContentBlockPayload | CreateFeedbackPayload | CreateFooterPayload | CreateMetaPayload | CreateOccupationPayload | CreatePlatformPayload | CreatePostPayload | CreateRedirectPayload | CreateRolePayload | CreateTestCollectionPayload | CreateUserPayload | CreateWebsitePayload | DeleteCategoryPayload | DeleteContactFormRequestPayload | DeleteContentBlockPayload | DeleteFeedbackPayload | DeleteFilePayload | DeleteFooterPayload | DeleteMetaPayload | DeleteOccupationPayload | DeletePlatformPayload | DeletePostPayload | DeleteRedirectPayload | DeleteRolePayload | DeleteTestCollectionPayload | DeleteUserPayload | DeleteWebsitePayload | UpdateCategoryPayload | UpdateContactFormRequestPayload | UpdateContentBlockPayload | UpdateFeedbackPayload | UpdateFooterPayload | UpdateMetaPayload | UpdateOccupationPayload | UpdatePlatformPayload | UpdatePostPayload | UpdateRedirectPayload | UpdateRolePayload | UpdateTestCollectionPayload | UpdateUserPayload | UpdateWebsitePayload;

export type Mutation = {
  createCategory?: Maybe<CreateCategoryPayload>;
  createContactFormRequest?: Maybe<CreateContactFormRequestPayload>;
  createContentBlock?: Maybe<CreateContentBlockPayload>;
  createContentBlockLocalization: ContentBlock;
  createFeedback?: Maybe<CreateFeedbackPayload>;
  createFooter?: Maybe<CreateFooterPayload>;
  createMeta?: Maybe<CreateMetaPayload>;
  createOccupation?: Maybe<CreateOccupationPayload>;
  createPlatform?: Maybe<CreatePlatformPayload>;
  createPost?: Maybe<CreatePostPayload>;
  createPostLocalization: Post;
  createRedirect?: Maybe<CreateRedirectPayload>;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  createTestCollection?: Maybe<CreateTestCollectionPayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  createWebsite?: Maybe<CreateWebsitePayload>;
  deleteCategory?: Maybe<DeleteCategoryPayload>;
  deleteContactFormRequest?: Maybe<DeleteContactFormRequestPayload>;
  deleteContentBlock?: Maybe<DeleteContentBlockPayload>;
  deleteFeedback?: Maybe<DeleteFeedbackPayload>;
  /** Delete one file */
  deleteFile?: Maybe<DeleteFilePayload>;
  deleteFooter?: Maybe<DeleteFooterPayload>;
  deleteMeta?: Maybe<DeleteMetaPayload>;
  deleteOccupation?: Maybe<DeleteOccupationPayload>;
  deletePlatform?: Maybe<DeletePlatformPayload>;
  deletePost?: Maybe<DeletePostPayload>;
  deleteRedirect?: Maybe<DeleteRedirectPayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  deleteTestCollection?: Maybe<DeleteTestCollectionPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  deleteWebsite?: Maybe<DeleteWebsitePayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFile>>;
  register: UsersPermissionsLoginPayload;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateCategory?: Maybe<UpdateCategoryPayload>;
  updateContactFormRequest?: Maybe<UpdateContactFormRequestPayload>;
  updateContentBlock?: Maybe<UpdateContentBlockPayload>;
  updateFeedback?: Maybe<UpdateFeedbackPayload>;
  updateFileInfo: UploadFile;
  updateFooter?: Maybe<UpdateFooterPayload>;
  updateMeta?: Maybe<UpdateMetaPayload>;
  updateOccupation?: Maybe<UpdateOccupationPayload>;
  updatePlatform?: Maybe<UpdatePlatformPayload>;
  updatePost?: Maybe<UpdatePostPayload>;
  updateRedirect?: Maybe<UpdateRedirectPayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  updateTestCollection?: Maybe<UpdateTestCollectionPayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  updateWebsite?: Maybe<UpdateWebsitePayload>;
  upload: UploadFile;
};


export type MutationCreateCategoryArgs = {
  input?: InputMaybe<CreateCategoryInput>;
};


export type MutationCreateContactFormRequestArgs = {
  input?: InputMaybe<CreateContactFormRequestInput>;
};


export type MutationCreateContentBlockArgs = {
  input?: InputMaybe<CreateContentBlockInput>;
};


export type MutationCreateContentBlockLocalizationArgs = {
  input: UpdateContentBlockInput;
};


export type MutationCreateFeedbackArgs = {
  input?: InputMaybe<CreateFeedbackInput>;
};


export type MutationCreateFooterArgs = {
  input?: InputMaybe<CreateFooterInput>;
};


export type MutationCreateMetaArgs = {
  input?: InputMaybe<CreateMetaInput>;
};


export type MutationCreateOccupationArgs = {
  input?: InputMaybe<CreateOccupationInput>;
};


export type MutationCreatePlatformArgs = {
  input?: InputMaybe<CreatePlatformInput>;
};


export type MutationCreatePostArgs = {
  input?: InputMaybe<CreatePostInput>;
};


export type MutationCreatePostLocalizationArgs = {
  input: UpdatePostInput;
};


export type MutationCreateRedirectArgs = {
  input?: InputMaybe<CreateRedirectInput>;
};


export type MutationCreateRoleArgs = {
  input?: InputMaybe<CreateRoleInput>;
};


export type MutationCreateTestCollectionArgs = {
  input?: InputMaybe<CreateTestCollectionInput>;
};


export type MutationCreateUserArgs = {
  input?: InputMaybe<CreateUserInput>;
};


export type MutationCreateWebsiteArgs = {
  input?: InputMaybe<CreateWebsiteInput>;
};


export type MutationDeleteCategoryArgs = {
  input?: InputMaybe<DeleteCategoryInput>;
};


export type MutationDeleteContactFormRequestArgs = {
  input?: InputMaybe<DeleteContactFormRequestInput>;
};


export type MutationDeleteContentBlockArgs = {
  input?: InputMaybe<DeleteContentBlockInput>;
};


export type MutationDeleteFeedbackArgs = {
  input?: InputMaybe<DeleteFeedbackInput>;
};


export type MutationDeleteFileArgs = {
  input?: InputMaybe<DeleteFileInput>;
};


export type MutationDeleteFooterArgs = {
  input?: InputMaybe<DeleteFooterInput>;
};


export type MutationDeleteMetaArgs = {
  input?: InputMaybe<DeleteMetaInput>;
};


export type MutationDeleteOccupationArgs = {
  input?: InputMaybe<DeleteOccupationInput>;
};


export type MutationDeletePlatformArgs = {
  input?: InputMaybe<DeletePlatformInput>;
};


export type MutationDeletePostArgs = {
  input?: InputMaybe<DeletePostInput>;
};


export type MutationDeleteRedirectArgs = {
  input?: InputMaybe<DeleteRedirectInput>;
};


export type MutationDeleteRoleArgs = {
  input?: InputMaybe<DeleteRoleInput>;
};


export type MutationDeleteTestCollectionArgs = {
  input?: InputMaybe<DeleteTestCollectionInput>;
};


export type MutationDeleteUserArgs = {
  input?: InputMaybe<DeleteUserInput>;
};


export type MutationDeleteWebsiteArgs = {
  input?: InputMaybe<DeleteWebsiteInput>;
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  files: Array<InputMaybe<Scalars['Upload']>>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<Scalars['String']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationResetPasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationUpdateCategoryArgs = {
  input?: InputMaybe<UpdateCategoryInput>;
};


export type MutationUpdateContactFormRequestArgs = {
  input?: InputMaybe<UpdateContactFormRequestInput>;
};


export type MutationUpdateContentBlockArgs = {
  input?: InputMaybe<UpdateContentBlockInput>;
};


export type MutationUpdateFeedbackArgs = {
  input?: InputMaybe<UpdateFeedbackInput>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info: FileInfoInput;
};


export type MutationUpdateFooterArgs = {
  input?: InputMaybe<UpdateFooterInput>;
};


export type MutationUpdateMetaArgs = {
  input?: InputMaybe<UpdateMetaInput>;
};


export type MutationUpdateOccupationArgs = {
  input?: InputMaybe<UpdateOccupationInput>;
};


export type MutationUpdatePlatformArgs = {
  input?: InputMaybe<UpdatePlatformInput>;
};


export type MutationUpdatePostArgs = {
  input?: InputMaybe<UpdatePostInput>;
};


export type MutationUpdateRedirectArgs = {
  input?: InputMaybe<UpdateRedirectInput>;
};


export type MutationUpdateRoleArgs = {
  input?: InputMaybe<UpdateRoleInput>;
};


export type MutationUpdateTestCollectionArgs = {
  input?: InputMaybe<UpdateTestCollectionInput>;
};


export type MutationUpdateUserArgs = {
  input?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateWebsiteArgs = {
  input?: InputMaybe<UpdateWebsiteInput>;
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<Scalars['String']>;
};

export type Occupation = {
  id: Scalars['ID'];
  name: Scalars['String'];
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type OccupationUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type OccupationAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OccupationConnection = {
  aggregate?: Maybe<OccupationAggregator>;
  groupBy?: Maybe<OccupationGroupBy>;
  values?: Maybe<Array<Maybe<Occupation>>>;
};

export type OccupationConnectionId = {
  connection?: Maybe<OccupationConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type OccupationConnectionName = {
  connection?: Maybe<OccupationConnection>;
  key?: Maybe<Scalars['String']>;
};

export type OccupationGroupBy = {
  id?: Maybe<Array<Maybe<OccupationConnectionId>>>;
  name?: Maybe<Array<Maybe<OccupationConnectionName>>>;
};

export type OccupationInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  updated_by?: InputMaybe<Scalars['ID']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type PlatformInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  description_card?: InputMaybe<Array<InputMaybe<ComponentOrganismsDescriptionCardInput>>>;
  features_title?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['ID']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type Platforms = {
  created_at: Scalars['DateTime'];
  description_card?: Maybe<Array<Maybe<ComponentOrganismsDescriptionCard>>>;
  features_title?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logo?: Maybe<UploadFile>;
  preview?: Maybe<UploadFile>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type PlatformsAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PlatformsConnection = {
  aggregate?: Maybe<PlatformsAggregator>;
  groupBy?: Maybe<PlatformsGroupBy>;
  values?: Maybe<Array<Maybe<Platforms>>>;
};

export type PlatformsConnectionCreated_At = {
  connection?: Maybe<PlatformsConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type PlatformsConnectionFeatures_Title = {
  connection?: Maybe<PlatformsConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PlatformsConnectionId = {
  connection?: Maybe<PlatformsConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PlatformsConnectionLogo = {
  connection?: Maybe<PlatformsConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PlatformsConnectionPreview = {
  connection?: Maybe<PlatformsConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PlatformsConnectionSubTitle = {
  connection?: Maybe<PlatformsConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PlatformsConnectionTitle = {
  connection?: Maybe<PlatformsConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PlatformsConnectionUpdated_At = {
  connection?: Maybe<PlatformsConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type PlatformsGroupBy = {
  created_at?: Maybe<Array<Maybe<PlatformsConnectionCreated_At>>>;
  features_title?: Maybe<Array<Maybe<PlatformsConnectionFeatures_Title>>>;
  id?: Maybe<Array<Maybe<PlatformsConnectionId>>>;
  logo?: Maybe<Array<Maybe<PlatformsConnectionLogo>>>;
  preview?: Maybe<Array<Maybe<PlatformsConnectionPreview>>>;
  subTitle?: Maybe<Array<Maybe<PlatformsConnectionSubTitle>>>;
  title?: Maybe<Array<Maybe<PlatformsConnectionTitle>>>;
  updated_at?: Maybe<Array<Maybe<PlatformsConnectionUpdated_At>>>;
};

export type Post = {
  authors?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  category?: Maybe<Category>;
  id: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Post>>>;
  meta?: Maybe<Array<Maybe<ComponentSeoMeta>>>;
  name: Scalars['String'];
  previews?: Maybe<UploadFile>;
  slug: Scalars['String'];
  source?: Maybe<ComponentAtomsLink>;
  text?: Maybe<Scalars['String']>;
};


export type PostAuthorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type PostLocalizationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type PostAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PostConnection = {
  aggregate?: Maybe<PostAggregator>;
  groupBy?: Maybe<PostGroupBy>;
  values?: Maybe<Array<Maybe<Post>>>;
};

export type PostConnectionCategory = {
  connection?: Maybe<PostConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PostConnectionId = {
  connection?: Maybe<PostConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PostConnectionLocale = {
  connection?: Maybe<PostConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PostConnectionName = {
  connection?: Maybe<PostConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PostConnectionPreviews = {
  connection?: Maybe<PostConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PostConnectionSlug = {
  connection?: Maybe<PostConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PostConnectionSource = {
  connection?: Maybe<PostConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PostConnectionText = {
  connection?: Maybe<PostConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PostGroupBy = {
  category?: Maybe<Array<Maybe<PostConnectionCategory>>>;
  id?: Maybe<Array<Maybe<PostConnectionId>>>;
  locale?: Maybe<Array<Maybe<PostConnectionLocale>>>;
  name?: Maybe<Array<Maybe<PostConnectionName>>>;
  previews?: Maybe<Array<Maybe<PostConnectionPreviews>>>;
  slug?: Maybe<Array<Maybe<PostConnectionSlug>>>;
  source?: Maybe<Array<Maybe<PostConnectionSource>>>;
  text?: Maybe<Array<Maybe<PostConnectionText>>>;
};

export type PostInput = {
  authors?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  category?: InputMaybe<Scalars['ID']>;
  created_by?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  meta?: InputMaybe<Array<InputMaybe<ComponentSeoMetaInput>>>;
  name: Scalars['String'];
  previews?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  source?: InputMaybe<ComponentAtomsLinkInput>;
  text?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type PublicationState =
  | 'LIVE'
  | 'PREVIEW';

export type Query = {
  categories?: Maybe<Array<Maybe<Category>>>;
  categoriesConnection?: Maybe<CategoryConnection>;
  category?: Maybe<Category>;
  contactFormRequest?: Maybe<ContactFormRequest>;
  contactFormRequests?: Maybe<Array<Maybe<ContactFormRequest>>>;
  contactFormRequestsConnection?: Maybe<ContactFormRequestConnection>;
  contentBlock?: Maybe<ContentBlock>;
  contentBlocks?: Maybe<Array<Maybe<ContentBlock>>>;
  contentBlocksConnection?: Maybe<ContentBlockConnection>;
  feedback?: Maybe<Feedback>;
  feedbacks?: Maybe<Array<Maybe<Feedback>>>;
  feedbacksConnection?: Maybe<FeedbackConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  footer?: Maybe<Footer>;
  footers?: Maybe<Array<Maybe<Footer>>>;
  footersConnection?: Maybe<FooterConnection>;
  me?: Maybe<UsersPermissionsMe>;
  meta?: Maybe<Meta>;
  metas?: Maybe<Array<Maybe<Meta>>>;
  metasConnection?: Maybe<MetaConnection>;
  occupation?: Maybe<Occupation>;
  occupations?: Maybe<Array<Maybe<Occupation>>>;
  occupationsConnection?: Maybe<OccupationConnection>;
  platform?: Maybe<Platforms>;
  platforms?: Maybe<Array<Maybe<Platforms>>>;
  platformsConnection?: Maybe<PlatformsConnection>;
  post?: Maybe<Post>;
  posts?: Maybe<Array<Maybe<Post>>>;
  postsConnection?: Maybe<PostConnection>;
  redirect?: Maybe<Redirect>;
  redirects?: Maybe<Array<Maybe<Redirect>>>;
  redirectsConnection?: Maybe<RedirectConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  testCollection?: Maybe<TestCollection>;
  testCollections?: Maybe<Array<Maybe<TestCollection>>>;
  testCollectionsConnection?: Maybe<TestCollectionConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  website?: Maybe<Website>;
  websites?: Maybe<Array<Maybe<Website>>>;
  websitesConnection?: Maybe<WebsiteConnection>;
};


export type QueryCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryCategoriesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryCategoryArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryContactFormRequestArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryContactFormRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryContactFormRequestsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryContentBlockArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryContentBlocksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryContentBlocksConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryFeedbackArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryFeedbacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryFeedbacksConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryFilesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryFilesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryFooterArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryFootersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryFootersConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryMetaArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryMetasArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryMetasConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryOccupationArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryOccupationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryOccupationsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryPlatformArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryPlatformsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryPlatformsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryPostArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryPostsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryPostsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryRedirectArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryRedirectsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryRedirectsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryRolesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryRolesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTestCollectionArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTestCollectionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryTestCollectionsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryUsersConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryWebsiteArgs = {
  id: Scalars['ID'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryWebsitesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type QueryWebsitesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type Redirect = {
  from: Scalars['String'];
  id: Scalars['ID'];
  to: Scalars['String'];
};

export type RedirectAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RedirectConnection = {
  aggregate?: Maybe<RedirectAggregator>;
  groupBy?: Maybe<RedirectGroupBy>;
  values?: Maybe<Array<Maybe<Redirect>>>;
};

export type RedirectConnectionFrom = {
  connection?: Maybe<RedirectConnection>;
  key?: Maybe<Scalars['String']>;
};

export type RedirectConnectionId = {
  connection?: Maybe<RedirectConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type RedirectConnectionTo = {
  connection?: Maybe<RedirectConnection>;
  key?: Maybe<Scalars['String']>;
};

export type RedirectGroupBy = {
  from?: Maybe<Array<Maybe<RedirectConnectionFrom>>>;
  id?: Maybe<Array<Maybe<RedirectConnectionId>>>;
  to?: Maybe<Array<Maybe<RedirectConnectionTo>>>;
};

export type RedirectInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  from: Scalars['String'];
  to: Scalars['String'];
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type RoleInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type TestCollection = {
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  testTitle?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type TestCollectionAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TestCollectionConnection = {
  aggregate?: Maybe<TestCollectionAggregator>;
  groupBy?: Maybe<TestCollectionGroupBy>;
  values?: Maybe<Array<Maybe<TestCollection>>>;
};

export type TestCollectionConnectionCreated_At = {
  connection?: Maybe<TestCollectionConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TestCollectionConnectionId = {
  connection?: Maybe<TestCollectionConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TestCollectionConnectionTestTitle = {
  connection?: Maybe<TestCollectionConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TestCollectionConnectionUpdated_At = {
  connection?: Maybe<TestCollectionConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TestCollectionGroupBy = {
  created_at?: Maybe<Array<Maybe<TestCollectionConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<TestCollectionConnectionId>>>;
  testTitle?: Maybe<Array<Maybe<TestCollectionConnectionTestTitle>>>;
  updated_at?: Maybe<Array<Maybe<TestCollectionConnectionUpdated_At>>>;
};

export type TestCollectionInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  testTitle?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type UploadFile = {
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  ext?: Maybe<Scalars['String']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Morph>>>;
  size: Scalars['Float'];
  updated_at: Scalars['DateTime'];
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};


export type UploadFileRelatedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type UploadFileAggregator = {
  avg?: Maybe<UploadFileAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<UploadFileAggregatorMax>;
  min?: Maybe<UploadFileAggregatorMin>;
  sum?: Maybe<UploadFileAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UploadFileAggregatorAvg = {
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorSum = {
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type UploadFileConnection = {
  aggregate?: Maybe<UploadFileAggregator>;
  groupBy?: Maybe<UploadFileGroupBy>;
  values?: Maybe<Array<Maybe<UploadFile>>>;
};

export type UploadFileConnectionAlternativeText = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionCaption = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionCreated_At = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type UploadFileConnectionExt = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionFormats = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['JSON']>;
};

export type UploadFileConnectionHash = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionHeight = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type UploadFileConnectionId = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UploadFileConnectionMime = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionName = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionPreviewUrl = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionProvider = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionProvider_Metadata = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['JSON']>;
};

export type UploadFileConnectionSize = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type UploadFileConnectionUpdated_At = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type UploadFileConnectionUrl = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionWidth = {
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type UploadFileGroupBy = {
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  created_at?: Maybe<Array<Maybe<UploadFileConnectionCreated_At>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  updated_at?: Maybe<Array<Maybe<UploadFileConnectionUpdated_At>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
};

export type UserInput = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  created_by?: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['ID']>;
  password?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['ID']>;
  provider?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['ID']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  username: Scalars['String'];
};

export type UserPermissionsPasswordPayload = {
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: InputMaybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String'];
};

export type UsersPermissionsMeRole = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPermission = {
  action: Scalars['String'];
  controller: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
  type: Scalars['String'];
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type UsersPermissionsRole = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  type?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type UsersPermissionsRoleAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsRoleConnection = {
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
};

export type UsersPermissionsRoleConnectionDescription = {
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRoleConnectionId = {
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsRoleConnectionName = {
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRoleConnectionType = {
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRoleGroupBy = {
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
};

export type UsersPermissionsUser = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  occupation?: Maybe<Occupation>;
  photo?: Maybe<UploadFile>;
  role?: Maybe<UsersPermissionsRole>;
  username: Scalars['String'];
};

export type UsersPermissionsUserAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsUserConnection = {
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};

export type UsersPermissionsUserConnectionEmail = {
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserConnectionFirstName = {
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserConnectionId = {
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserConnectionLastName = {
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserConnectionOccupation = {
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserConnectionPhoto = {
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserConnectionRole = {
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserConnectionUsername = {
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserGroupBy = {
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  firstName?: Maybe<Array<Maybe<UsersPermissionsUserConnectionFirstName>>>;
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  lastName?: Maybe<Array<Maybe<UsersPermissionsUserConnectionLastName>>>;
  occupation?: Maybe<Array<Maybe<UsersPermissionsUserConnectionOccupation>>>;
  photo?: Maybe<Array<Maybe<UsersPermissionsUserConnectionPhoto>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
};

export type Website = {
  domain: Scalars['String'];
  id: Scalars['ID'];
  navigation?: Maybe<Array<Maybe<ComponentMoleculesMenu>>>;
  seo?: Maybe<Array<Maybe<ComponentMoleculesMap>>>;
};

export type WebsiteAggregator = {
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type WebsiteConnection = {
  aggregate?: Maybe<WebsiteAggregator>;
  groupBy?: Maybe<WebsiteGroupBy>;
  values?: Maybe<Array<Maybe<Website>>>;
};

export type WebsiteConnectionDomain = {
  connection?: Maybe<WebsiteConnection>;
  key?: Maybe<Scalars['String']>;
};

export type WebsiteConnectionId = {
  connection?: Maybe<WebsiteConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type WebsiteGroupBy = {
  domain?: Maybe<Array<Maybe<WebsiteConnectionDomain>>>;
  id?: Maybe<Array<Maybe<WebsiteConnectionId>>>;
};

export type WebsiteInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  domain: Scalars['String'];
  navigation?: InputMaybe<Array<InputMaybe<ComponentMoleculesMenuInput>>>;
  seo?: InputMaybe<Array<ComponentMoleculesMapInput>>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type CreateCategoryInput = {
  data?: InputMaybe<CategoryInput>;
};

export type CreateCategoryPayload = {
  category?: Maybe<Category>;
};

export type CreateContactFormRequestInput = {
  data?: InputMaybe<ContactFormRequestInput>;
};

export type CreateContactFormRequestPayload = {
  contactFormRequest?: Maybe<ContactFormRequest>;
};

export type CreateContentBlockInput = {
  data?: InputMaybe<ContentBlockInput>;
};

export type CreateContentBlockPayload = {
  contentBlock?: Maybe<ContentBlock>;
};

export type CreateFeedbackInput = {
  data?: InputMaybe<FeedbackInput>;
};

export type CreateFeedbackPayload = {
  feedback?: Maybe<Feedback>;
};

export type CreateFooterInput = {
  data?: InputMaybe<FooterInput>;
};

export type CreateFooterPayload = {
  footer?: Maybe<Footer>;
};

export type CreateMetaInput = {
  data?: InputMaybe<MetaInput>;
};

export type CreateMetaPayload = {
  meta?: Maybe<Meta>;
};

export type CreateOccupationInput = {
  data?: InputMaybe<OccupationInput>;
};

export type CreateOccupationPayload = {
  occupation?: Maybe<Occupation>;
};

export type CreatePlatformInput = {
  data?: InputMaybe<PlatformInput>;
};

export type CreatePlatformPayload = {
  platform?: Maybe<Platforms>;
};

export type CreatePostInput = {
  data?: InputMaybe<PostInput>;
};

export type CreatePostPayload = {
  post?: Maybe<Post>;
};

export type CreateRedirectInput = {
  data?: InputMaybe<RedirectInput>;
};

export type CreateRedirectPayload = {
  redirect?: Maybe<Redirect>;
};

export type CreateRoleInput = {
  data?: InputMaybe<RoleInput>;
};

export type CreateRolePayload = {
  role?: Maybe<UsersPermissionsRole>;
};

export type CreateTestCollectionInput = {
  data?: InputMaybe<TestCollectionInput>;
};

export type CreateTestCollectionPayload = {
  testCollection?: Maybe<TestCollection>;
};

export type CreateUserInput = {
  data?: InputMaybe<UserInput>;
};

export type CreateUserPayload = {
  user?: Maybe<UsersPermissionsUser>;
};

export type CreateWebsiteInput = {
  data?: InputMaybe<WebsiteInput>;
};

export type CreateWebsitePayload = {
  website?: Maybe<Website>;
};

export type DeleteCategoryInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteCategoryPayload = {
  category?: Maybe<Category>;
};

export type DeleteContactFormRequestInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteContactFormRequestPayload = {
  contactFormRequest?: Maybe<ContactFormRequest>;
};

export type DeleteContentBlockInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteContentBlockPayload = {
  contentBlock?: Maybe<ContentBlock>;
};

export type DeleteFeedbackInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteFeedbackPayload = {
  feedback?: Maybe<Feedback>;
};

export type DeleteFileInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteFilePayload = {
  file?: Maybe<UploadFile>;
};

export type DeleteFooterInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteFooterPayload = {
  footer?: Maybe<Footer>;
};

export type DeleteMetaInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteMetaPayload = {
  meta?: Maybe<Meta>;
};

export type DeleteOccupationInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteOccupationPayload = {
  occupation?: Maybe<Occupation>;
};

export type DeletePlatformInput = {
  where?: InputMaybe<InputId>;
};

export type DeletePlatformPayload = {
  platform?: Maybe<Platforms>;
};

export type DeletePostInput = {
  where?: InputMaybe<InputId>;
};

export type DeletePostPayload = {
  post?: Maybe<Post>;
};

export type DeleteRedirectInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteRedirectPayload = {
  redirect?: Maybe<Redirect>;
};

export type DeleteRoleInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteRolePayload = {
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteTestCollectionInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteTestCollectionPayload = {
  testCollection?: Maybe<TestCollection>;
};

export type DeleteUserInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteUserPayload = {
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteWebsiteInput = {
  where?: InputMaybe<InputId>;
};

export type DeleteWebsitePayload = {
  website?: Maybe<Website>;
};

export type EditCategoryInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ID']>;
  posts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  scope?: InputMaybe<Enum_Category_Scope>;
  slug?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditComponentAtomsButtonInput = {
  id?: InputMaybe<Scalars['ID']>;
  link?: InputMaybe<EditComponentAtomsLinkInput>;
  simpleIcon?: InputMaybe<Scalars['String']>;
};

export type EditComponentAtomsEntryInput = {
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type EditComponentAtomsLinkInput = {
  id?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type EditComponentAtomsNumericInput = {
  id?: InputMaybe<Scalars['ID']>;
  unit?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type EditComponentAtomsParagraphInput = {
  id?: InputMaybe<Scalars['ID']>;
  lines?: InputMaybe<Array<InputMaybe<EditComponentAtomsTextInput>>>;
};

export type EditComponentAtomsTextInput = {
  id?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Scalars['String']>;
};

export type EditComponentMoleculesDescriptionInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EditComponentMoleculesEmailInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type EditComponentMoleculesFeedbackTextInput = {
  id?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EditComponentMoleculesItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EditComponentMoleculesListInput = {
  feature01?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type EditComponentMoleculesMapInput = {
  entries?: InputMaybe<Array<InputMaybe<EditComponentAtomsEntryInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type EditComponentMoleculesMenuInput = {
  id?: InputMaybe<Scalars['ID']>;
  links?: InputMaybe<Array<InputMaybe<EditComponentAtomsLinkInput>>>;
  slug?: InputMaybe<Scalars['String']>;
};

export type EditComponentMoleculesPrivacyInput = {
  id?: InputMaybe<Scalars['ID']>;
  link?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EditComponentMoleculesSocialInput = {
  icon?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  link?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EditComponentOrganismsArticleInput = {
  cards?: InputMaybe<Array<InputMaybe<EditComponentOrganismsSectionInput>>>;
  entries?: InputMaybe<Array<InputMaybe<EditComponentAtomsEntryInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  link?: InputMaybe<EditComponentAtomsLinkInput>;
  section?: InputMaybe<EditComponentOrganismsSectionInput>;
  slug?: InputMaybe<Scalars['String']>;
};

export type EditComponentOrganismsDescriptionCardInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EditComponentOrganismsPageInput = {
  id?: InputMaybe<Scalars['ID']>;
  meta?: InputMaybe<Array<InputMaybe<EditComponentAtomsEntryInput>>>;
  uri?: InputMaybe<Scalars['String']>;
};

export type EditComponentOrganismsSectionInput = {
  Features?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  activeFirstButton?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  formIdModal?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Scalars['ID']>;
  media_slides?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  slug?: InputMaybe<Scalars['String']>;
  subDescription?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  urlButton?: InputMaybe<Scalars['String']>;
  videoDesktop?: InputMaybe<Scalars['ID']>;
  videoMobile?: InputMaybe<Scalars['ID']>;
};

export type EditComponentSeoMetaInput = {
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Enum_Componentseometa_Name>;
};

export type EditComponentSeoMetaNameInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type EditContactFormRequestInput = {
  clubName?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  website?: InputMaybe<Scalars['String']>;
};

export type EditContentBlockInput = {
  button?: InputMaybe<EditComponentAtomsButtonInput>;
  cards?: InputMaybe<Array<InputMaybe<EditComponentOrganismsSectionInput>>>;
  created_by?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  entries?: InputMaybe<Array<InputMaybe<EditComponentMoleculesMapInput>>>;
  locale?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  section?: InputMaybe<EditComponentOrganismsSectionInput>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditEmailTemplateInput = {
  bodyHtml?: InputMaybe<Scalars['String']>;
  bodyText?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  design?: InputMaybe<Scalars['JSON']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  sourceCodeToTemplateId?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['JSON']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditFeedbackInput = {
  client?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  decktop_slide?: InputMaybe<Scalars['ID']>;
  feedbackText?: InputMaybe<Array<InputMaybe<EditComponentMoleculesFeedbackTextInput>>>;
  isInvert?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['ID']>;
  mobile_slide?: InputMaybe<Scalars['ID']>;
  person?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditFileInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  ext?: InputMaybe<Scalars['String']>;
  formats?: InputMaybe<Scalars['JSON']>;
  hash?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  mime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  previewUrl?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  provider_metadata?: InputMaybe<Scalars['JSON']>;
  related?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  size?: InputMaybe<Scalars['Float']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type EditFooterInput = {
  address?: InputMaybe<Scalars['String']>;
  addressMapUrl?: InputMaybe<Scalars['String']>;
  contactsTitle?: InputMaybe<Scalars['String']>;
  copyrights?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  emails?: InputMaybe<Array<InputMaybe<EditComponentMoleculesEmailInput>>>;
  phone?: InputMaybe<Scalars['String']>;
  privacy?: InputMaybe<EditComponentMoleculesPrivacyInput>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  socials?: InputMaybe<Array<InputMaybe<EditComponentMoleculesSocialInput>>>;
  starText?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditLocaleInput = {
  code?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditMetaInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  meta?: InputMaybe<Array<InputMaybe<EditComponentSeoMetaInput>>>;
  pathname?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditOccupationInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type EditPlatformInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  description_card?: InputMaybe<Array<InputMaybe<EditComponentOrganismsDescriptionCardInput>>>;
  features_title?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['ID']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditPostInput = {
  authors?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  category?: InputMaybe<Scalars['ID']>;
  created_by?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  meta?: InputMaybe<Array<InputMaybe<EditComponentSeoMetaInput>>>;
  name?: InputMaybe<Scalars['String']>;
  previews?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<EditComponentAtomsLinkInput>;
  text?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditRedirectInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditRoleInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type EditTestCollectionInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  published_at?: InputMaybe<Scalars['DateTime']>;
  testTitle?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type EditUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  created_by?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['ID']>;
  password?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['ID']>;
  provider?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['ID']>;
  updated_by?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type EditWebsiteInput = {
  created_by?: InputMaybe<Scalars['ID']>;
  domain?: InputMaybe<Scalars['String']>;
  navigation?: InputMaybe<Array<InputMaybe<EditComponentMoleculesMenuInput>>>;
  seo?: InputMaybe<Array<InputMaybe<EditComponentMoleculesMapInput>>>;
  updated_by?: InputMaybe<Scalars['ID']>;
};

export type UpdateCategoryInput = {
  data?: InputMaybe<EditCategoryInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateCategoryPayload = {
  category?: Maybe<Category>;
};

export type UpdateContactFormRequestInput = {
  data?: InputMaybe<EditContactFormRequestInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateContactFormRequestPayload = {
  contactFormRequest?: Maybe<ContactFormRequest>;
};

export type UpdateContentBlockInput = {
  data?: InputMaybe<EditContentBlockInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateContentBlockPayload = {
  contentBlock?: Maybe<ContentBlock>;
};

export type UpdateFeedbackInput = {
  data?: InputMaybe<EditFeedbackInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateFeedbackPayload = {
  feedback?: Maybe<Feedback>;
};

export type UpdateFooterInput = {
  data?: InputMaybe<EditFooterInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateFooterPayload = {
  footer?: Maybe<Footer>;
};

export type UpdateMetaInput = {
  data?: InputMaybe<EditMetaInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateMetaPayload = {
  meta?: Maybe<Meta>;
};

export type UpdateOccupationInput = {
  data?: InputMaybe<EditOccupationInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateOccupationPayload = {
  occupation?: Maybe<Occupation>;
};

export type UpdatePlatformInput = {
  data?: InputMaybe<EditPlatformInput>;
  where?: InputMaybe<InputId>;
};

export type UpdatePlatformPayload = {
  platform?: Maybe<Platforms>;
};

export type UpdatePostInput = {
  data?: InputMaybe<EditPostInput>;
  where?: InputMaybe<InputId>;
};

export type UpdatePostPayload = {
  post?: Maybe<Post>;
};

export type UpdateRedirectInput = {
  data?: InputMaybe<EditRedirectInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateRedirectPayload = {
  redirect?: Maybe<Redirect>;
};

export type UpdateRoleInput = {
  data?: InputMaybe<EditRoleInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateRolePayload = {
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateTestCollectionInput = {
  data?: InputMaybe<EditTestCollectionInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateTestCollectionPayload = {
  testCollection?: Maybe<TestCollection>;
};

export type UpdateUserInput = {
  data?: InputMaybe<EditUserInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateUserPayload = {
  user?: Maybe<UsersPermissionsUser>;
};

export type UpdateWebsiteInput = {
  data?: InputMaybe<EditWebsiteInput>;
  where?: InputMaybe<InputId>;
};

export type UpdateWebsitePayload = {
  website?: Maybe<Website>;
};

export type ButtonFragment = { id: string, simpleIcon?: string | null, link?: { id: string, text: string, title?: string | null, url: string } | null };

export type CategoryFragment = { id: string, name: string, slug: string };

export type ContentFragment = { id: string, title: string, description?: string | null, slug: string, button?: { id: string, simpleIcon?: string | null, link?: { id: string, text: string, title?: string | null, url: string } | null } | null, section?: { id: string, title?: string | null, subTitle?: string | null, active?: boolean | null, description?: string | null, subDescription?: string | null, backgroundColor?: string | null, text?: string | null, slug?: string | null, buttonText?: string | null, urlButton?: string | null, activeFirstButton?: boolean | null, media?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, media_slides?: Array<{ id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null> | null, videoDesktop?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, videoMobile?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null } | null, cards?: Array<{ id: string, title?: string | null, subTitle?: string | null, active?: boolean | null, description?: string | null, subDescription?: string | null, backgroundColor?: string | null, text?: string | null, slug?: string | null, formIdModal?: string | null, buttonText?: string | null, urlButton?: string | null, activeFirstButton?: boolean | null, media?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, media_slides?: Array<{ id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null> | null, videoDesktop?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, videoMobile?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null } | null> | null, entries?: Array<{ id: string, slug: string, entries?: Array<{ id: string, key: string, value?: string | null } | null> | null } | null> | null };

export type EntryFragment = { id: string, key: string, value?: string | null };

export type FeedbackFragment = { id: string, client?: string | null, person?: string | null, isInvert?: boolean | null, logo?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, mobile_slide?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, decktop_slide?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, feedbackText?: Array<{ text?: string | null } | null> | null };

export type FileFragment = { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null };

export type FooterFragment = { id: string, address?: string | null, addressMapUrl?: string | null, contactsTitle?: string | null, copyrights?: string | null, phone?: string | null, emails?: Array<{ email?: string | null } | null> | null, privacy?: { title?: string | null, link?: string | null } | null, socials?: Array<{ title?: string | null, link?: string | null, icon?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null } | null> | null };

export type LinkFragment = { id: string, text: string, title?: string | null, url: string };

export type MapFragment = { id: string, slug: string, entries?: Array<{ id: string, key: string, value?: string | null } | null> | null };

export type MetaFragment = { id: string, content: string, name?: Enum_Componentseometa_Name | null };

export type NumericFragment = { id: string, value: number, unit?: string | null };

export type OccupationFragment = { id: string, name: string };

export type PlatformFragment = { id: string, title?: string | null, subTitle?: string | null, features_title?: string | null, logo?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, preview?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, description_card?: Array<{ description?: string | null, title?: string | null } | null> | null };

export type PostFragment = { id: string, slug: string, name: string, text?: string | null, meta?: Array<{ id: string, content: string, name?: Enum_Componentseometa_Name | null } | null> | null, previews?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, category?: { id: string, name: string, slug: string } | null, authors?: Array<{ id: string, firstName?: string | null, lastName?: string | null, photo?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, occupation?: { id: string, name: string } | null } | null> | null, source?: { id: string, text: string, title?: string | null, url: string } | null };

export type SectionFragment = { id: string, title?: string | null, subTitle?: string | null, active?: boolean | null, description?: string | null, subDescription?: string | null, backgroundColor?: string | null, text?: string | null, slug?: string | null, buttonText?: string | null, urlButton?: string | null, activeFirstButton?: boolean | null, media?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, media_slides?: Array<{ id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null> | null, videoDesktop?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, videoMobile?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null };

export type SeoFragment = { id: string, title?: string | null, pathname: string, meta?: Array<{ id: string, content: string, name?: Enum_Componentseometa_Name | null } | null> | null };

export type TextFragment = { id: string, value: string };

export type UserFragment = { id: string, firstName?: string | null, lastName?: string | null, photo?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, occupation?: { id: string, name: string } | null };

export type ContentQueryVariables = Exact<{ [key: string]: never; }>;


export type ContentQuery = { contentBlocks?: Array<{ id: string, title: string, description?: string | null, slug: string, button?: { id: string, simpleIcon?: string | null, link?: { id: string, text: string, title?: string | null, url: string } | null } | null, section?: { id: string, title?: string | null, subTitle?: string | null, active?: boolean | null, description?: string | null, subDescription?: string | null, backgroundColor?: string | null, text?: string | null, slug?: string | null, buttonText?: string | null, urlButton?: string | null, activeFirstButton?: boolean | null, media?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, media_slides?: Array<{ id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null> | null, videoDesktop?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, videoMobile?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null } | null, cards?: Array<{ id: string, title?: string | null, subTitle?: string | null, active?: boolean | null, description?: string | null, subDescription?: string | null, backgroundColor?: string | null, text?: string | null, slug?: string | null, buttonText?: string | null, urlButton?: string | null, activeFirstButton?: boolean | null, media?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, media_slides?: Array<{ id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null> | null, videoDesktop?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, videoMobile?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null } | null> | null, entries?: Array<{ id: string, slug: string, entries?: Array<{ id: string, key: string, value?: string | null } | null> | null } | null> | null } | null> | null };

export type FeedbackQueryVariables = Exact<{ [key: string]: never; }>;


export type FeedbackQuery = { feedbacks?: Array<{ id: string, client?: string | null, person?: string | null, isInvert?: boolean | null, logo?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, mobile_slide?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, decktop_slide?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, feedbackText?: Array<{ text?: string | null } | null> | null } | null> | null };

export type FooterQueryVariables = Exact<{ [key: string]: never; }>;


export type FooterQuery = { footers?: Array<{ id: string, address?: string | null, addressMapUrl?: string | null, contactsTitle?: string | null, copyrights?: string | null, phone?: string | null, emails?: Array<{ email?: string | null } | null> | null, privacy?: { title?: string | null, link?: string | null } | null, socials?: Array<{ title?: string | null, link?: string | null, icon?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null } | null> | null } | null> | null };

export type MetaQueryVariables = Exact<{
  where?: InputMaybe<Scalars['JSON']>;
}>;


export type MetaQuery = { metas?: Array<{ id: string, title?: string | null, pathname: string, meta?: Array<{ id: string, content: string, name?: Enum_Componentseometa_Name | null } | null> | null } | null> | null };

export type MetasQueryVariables = Exact<{ [key: string]: never; }>;


export type MetasQuery = { metas?: Array<{ id: string, title?: string | null, pathname: string, meta?: Array<{ id: string, content: string, name?: Enum_Componentseometa_Name | null } | null> | null } | null> | null };

export type PlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformsQuery = { platforms?: Array<{ id: string, title?: string | null, subTitle?: string | null, features_title?: string | null, logo?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, preview?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, description_card?: Array<{ description?: string | null, title?: string | null } | null> | null } | null> | null };

export type PostsQueryVariables = Exact<{
  where?: InputMaybe<Scalars['JSON']>;
}>;


export type PostsQuery = { posts?: Array<{ id: string, slug: string, name: string, text?: string | null, meta?: Array<{ id: string, content: string, name?: Enum_Componentseometa_Name | null } | null> | null, category?: { id: string, name: string, slug: string } | null, previews?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, authors?: Array<{ id: string, firstName?: string | null, lastName?: string | null, photo?: { id: string, alternativeText?: string | null, caption?: string | null, name: string, previewUrl?: string | null, size: number, url: string, height?: number | null, width?: number | null } | null, occupation?: { id: string, name: string } | null } | null> | null, source?: { id: string, text: string, title?: string | null, url: string } | null } | null> | null };

export const LinkFragmentDoc = gql`
    fragment Link on ComponentAtomsLink {
  id
  text
  title
  url
}
    `;
export const ButtonFragmentDoc = gql`
    fragment Button on ComponentAtomsButton {
  id
  link {
    ...Link
  }
  simpleIcon
}
    ${LinkFragmentDoc}`;
export const FileFragmentDoc = gql`
    fragment File on UploadFile {
  id
  alternativeText
  caption
  name
  previewUrl
  size
  url
  height
  width
}
    `;
export const SectionFragmentDoc = gql`
    fragment Section on ComponentOrganismsSection {
  id
  title
  subTitle
  active
  description
  subDescription
  backgroundColor
  text
  slug
  buttonText
  urlButton
  activeFirstButton
  media {
    ...File
  }
  media_slides {
    ...File
  }
  videoDesktop {
    ...File
  }
  videoMobile {
    ...File
  }
}
    ${FileFragmentDoc}`;
export const EntryFragmentDoc = gql`
    fragment Entry on ComponentAtomsEntry {
  id
  key
  value
}
    `;
export const MapFragmentDoc = gql`
    fragment Map on ComponentMoleculesMap {
  id
  slug
  entries {
    ...Entry
  }
}
    ${EntryFragmentDoc}`;
export const ContentFragmentDoc = gql`
    fragment Content on ContentBlock {
  id
  title
  description
  slug
  button {
    ...Button
  }
  section {
    ...Section
  }
  cards {
    ...Section
  }
  entries {
    ...Map
  }
}
    ${ButtonFragmentDoc}
${SectionFragmentDoc}
${MapFragmentDoc}`;
export const FeedbackFragmentDoc = gql`
    fragment Feedback on Feedback {
  id
  client
  person
  logo {
    ...File
  }
  mobile_slide {
    ...File
  }
  decktop_slide {
    ...File
  }
  isInvert
  feedbackText {
    text
  }
}
    ${FileFragmentDoc}`;
export const FooterFragmentDoc = gql`
    fragment Footer on Footer {
  id
  address
  addressMapUrl
  contactsTitle
  copyrights
  emails {
    email
  }
  phone
  privacy {
    title
    link
  }
  socials {
    title
    link
    icon {
      ...File
    }
  }
}
    ${FileFragmentDoc}`;
export const NumericFragmentDoc = gql`
    fragment Numeric on ComponentAtomsNumeric {
  id
  value
  unit
}
    `;
export const PlatformFragmentDoc = gql`
    fragment Platform on Platforms {
  id
  title
  subTitle
  logo {
    ...File
  }
  preview {
    ...File
  }
  description_card {
    description
    title
  }
  features_title
}
    ${FileFragmentDoc}`;
export const MetaFragmentDoc = gql`
    fragment Meta on ComponentSeoMeta {
  id
  content
  name
}
    `;
export const CategoryFragmentDoc = gql`
    fragment Category on Category {
  id
  name
  slug
}
    `;
export const OccupationFragmentDoc = gql`
    fragment Occupation on Occupation {
  id
  name
}
    `;
export const UserFragmentDoc = gql`
    fragment User on UsersPermissionsUser {
  id
  firstName
  lastName
  photo {
    ...File
  }
  occupation {
    ...Occupation
  }
}
    ${FileFragmentDoc}
${OccupationFragmentDoc}`;
export const PostFragmentDoc = gql`
    fragment Post on Post {
  id
  slug
  name
  text
  meta {
    ...Meta
  }
  previews {
    ...File
  }
  category {
    ...Category
  }
  authors {
    ...User
  }
  source {
    ...Link
  }
}
    ${MetaFragmentDoc}
${FileFragmentDoc}
${CategoryFragmentDoc}
${UserFragmentDoc}
${LinkFragmentDoc}`;
export const SeoFragmentDoc = gql`
    fragment Seo on Meta {
  id
  title
  pathname
  meta {
    ...Meta
  }
}
    ${MetaFragmentDoc}`;
export const TextFragmentDoc = gql`
    fragment Text on ComponentAtomsText {
  id
  value
}
    `;
export const ContentDocument = gql`
    query content {
  contentBlocks {
    ...Content
  }
}
    ${ContentFragmentDoc}`;
export type ContentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ContentQuery, ContentQueryVariables>, 'query'>;

export const ContentComponent = (props: ContentComponentProps) => (
  <ApolloReactComponents.Query<ContentQuery, ContentQueryVariables> query={ContentDocument} {...props} />
);


/**
 * __useContentQuery__
 *
 * To run a query within a React component, call `useContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useContentQuery(baseOptions?: Apollo.QueryHookOptions<ContentQuery, ContentQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
}
export function useContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentQuery, ContentQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
}
export type ContentQueryHookResult = ReturnType<typeof useContentQuery>;
export type ContentLazyQueryHookResult = ReturnType<typeof useContentLazyQuery>;
export type ContentQueryResult = Apollo.QueryResult<ContentQuery, ContentQueryVariables>;
export const FeedbackDocument = gql`
    query feedback {
  feedbacks {
    ...Feedback
  }
}
    ${FeedbackFragmentDoc}`;
export type FeedbackComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FeedbackQuery, FeedbackQueryVariables>, 'query'>;

export const FeedbackComponent = (props: FeedbackComponentProps) => (
  <ApolloReactComponents.Query<FeedbackQuery, FeedbackQueryVariables> query={FeedbackDocument} {...props} />
);


/**
 * __useFeedbackQuery__
 *
 * To run a query within a React component, call `useFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeedbackQuery(baseOptions?: Apollo.QueryHookOptions<FeedbackQuery, FeedbackQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FeedbackQuery, FeedbackQueryVariables>(FeedbackDocument, options);
}
export function useFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackQuery, FeedbackQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FeedbackQuery, FeedbackQueryVariables>(FeedbackDocument, options);
}
export type FeedbackQueryHookResult = ReturnType<typeof useFeedbackQuery>;
export type FeedbackLazyQueryHookResult = ReturnType<typeof useFeedbackLazyQuery>;
export type FeedbackQueryResult = Apollo.QueryResult<FeedbackQuery, FeedbackQueryVariables>;
export const FooterDocument = gql`
    query footer {
  footers {
    ...Footer
  }
}
    ${FooterFragmentDoc}`;
export type FooterComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FooterQuery, FooterQueryVariables>, 'query'>;

export const FooterComponent = (props: FooterComponentProps) => (
  <ApolloReactComponents.Query<FooterQuery, FooterQueryVariables> query={FooterDocument} {...props} />
);


/**
 * __useFooterQuery__
 *
 * To run a query within a React component, call `useFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFooterQuery({
 *   variables: {
 *   },
 * });
 */
export function useFooterQuery(baseOptions?: Apollo.QueryHookOptions<FooterQuery, FooterQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FooterQuery, FooterQueryVariables>(FooterDocument, options);
}
export function useFooterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FooterQuery, FooterQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FooterQuery, FooterQueryVariables>(FooterDocument, options);
}
export type FooterQueryHookResult = ReturnType<typeof useFooterQuery>;
export type FooterLazyQueryHookResult = ReturnType<typeof useFooterLazyQuery>;
export type FooterQueryResult = Apollo.QueryResult<FooterQuery, FooterQueryVariables>;
export const MetaDocument = gql`
    query meta($where: JSON) {
  metas(where: $where, sort: "id:ASC", limit: 50) {
    ...Seo
  }
}
    ${SeoFragmentDoc}`;
export type MetaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MetaQuery, MetaQueryVariables>, 'query'>;

export const MetaComponent = (props: MetaComponentProps) => (
  <ApolloReactComponents.Query<MetaQuery, MetaQueryVariables> query={MetaDocument} {...props} />
);


/**
 * __useMetaQuery__
 *
 * To run a query within a React component, call `useMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMetaQuery(baseOptions?: Apollo.QueryHookOptions<MetaQuery, MetaQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MetaQuery, MetaQueryVariables>(MetaDocument, options);
}
export function useMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaQuery, MetaQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MetaQuery, MetaQueryVariables>(MetaDocument, options);
}
export type MetaQueryHookResult = ReturnType<typeof useMetaQuery>;
export type MetaLazyQueryHookResult = ReturnType<typeof useMetaLazyQuery>;
export type MetaQueryResult = Apollo.QueryResult<MetaQuery, MetaQueryVariables>;
export const MetasDocument = gql`
    query metas {
  metas {
    ...Seo
  }
}
    ${SeoFragmentDoc}`;
export type MetasComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MetasQuery, MetasQueryVariables>, 'query'>;

export const MetasComponent = (props: MetasComponentProps) => (
  <ApolloReactComponents.Query<MetasQuery, MetasQueryVariables> query={MetasDocument} {...props} />
);


/**
 * __useMetasQuery__
 *
 * To run a query within a React component, call `useMetasQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetasQuery({
 *   variables: {
 *   },
 * });
 */
export function useMetasQuery(baseOptions?: Apollo.QueryHookOptions<MetasQuery, MetasQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MetasQuery, MetasQueryVariables>(MetasDocument, options);
}
export function useMetasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetasQuery, MetasQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MetasQuery, MetasQueryVariables>(MetasDocument, options);
}
export type MetasQueryHookResult = ReturnType<typeof useMetasQuery>;
export type MetasLazyQueryHookResult = ReturnType<typeof useMetasLazyQuery>;
export type MetasQueryResult = Apollo.QueryResult<MetasQuery, MetasQueryVariables>;
export const PlatformsDocument = gql`
    query platforms {
  platforms {
    ...Platform
  }
}
    ${PlatformFragmentDoc}`;
export type PlatformsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PlatformsQuery, PlatformsQueryVariables>, 'query'>;

export const PlatformsComponent = (props: PlatformsComponentProps) => (
  <ApolloReactComponents.Query<PlatformsQuery, PlatformsQueryVariables> query={PlatformsDocument} {...props} />
);


/**
 * __usePlatformsQuery__
 *
 * To run a query within a React component, call `usePlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlatformsQuery(baseOptions?: Apollo.QueryHookOptions<PlatformsQuery, PlatformsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PlatformsQuery, PlatformsQueryVariables>(PlatformsDocument, options);
}
export function usePlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatformsQuery, PlatformsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PlatformsQuery, PlatformsQueryVariables>(PlatformsDocument, options);
}
export type PlatformsQueryHookResult = ReturnType<typeof usePlatformsQuery>;
export type PlatformsLazyQueryHookResult = ReturnType<typeof usePlatformsLazyQuery>;
export type PlatformsQueryResult = Apollo.QueryResult<PlatformsQuery, PlatformsQueryVariables>;
export const PostsDocument = gql`
    query posts($where: JSON) {
  posts(publicationState: LIVE, where: $where) {
    ...Post
    meta {
      ...Meta
    }
    category {
      ...Category
    }
    previews {
      ...File
    }
    authors {
      ...User
    }
    source {
      ...Link
    }
  }
}
    ${PostFragmentDoc}
${MetaFragmentDoc}
${CategoryFragmentDoc}
${FileFragmentDoc}
${UserFragmentDoc}
${LinkFragmentDoc}`;
export type PostsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PostsQuery, PostsQueryVariables>, 'query'>;

export const PostsComponent = (props: PostsComponentProps) => (
  <ApolloReactComponents.Query<PostsQuery, PostsQueryVariables> query={PostsDocument} {...props} />
);


/**
 * __usePostsQuery__
 *
 * To run a query within a React component, call `usePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePostsQuery(baseOptions?: Apollo.QueryHookOptions<PostsQuery, PostsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PostsQuery, PostsQueryVariables>(PostsDocument, options);
}
export function usePostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostsQuery, PostsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PostsQuery, PostsQueryVariables>(PostsDocument, options);
}
export type PostsQueryHookResult = ReturnType<typeof usePostsQuery>;
export type PostsLazyQueryHookResult = ReturnType<typeof usePostsLazyQuery>;
export type PostsQueryResult = Apollo.QueryResult<PostsQuery, PostsQueryVariables>;